import { ActionTypes as action } from "./action-types";
import { initialState } from './state';

const mutations = {
    [action.GET_DIRECTORY_LIST](state, data) {
        state.directoryList = data;
    },
    [action.RESET_STATE](state) {
        Object.assign(state, initialState);
    },
};

export default mutations;
